export default class WpEventArgs {
    static get Empty(): WpEventArgs {
        return new WpEventArgs();
    }
}